// src/components/SupportModal.jsx
import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

export default function SupportModal({ irisPhone = "69XXXXXXXX", open, onClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [copied, setCopied] = React.useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(irisPhone);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      scroll="paper"
    >
      <DialogTitle>Στήριξε το εγχείρημα ☕</DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Αν σε βοηθά το TeacherOnTheRoad, στήριξε την εξέλιξή του με μια μικρή
          συνεισφορά μέσω IRIS. Κάθε στήριξη μετράει — ευχαριστώ!
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          alignItems={{ xs: "flex-start", sm: "center" }}
          sx={{ mb: 1 }}
        >
          <Typography variant="subtitle2">IRIS (κινητό):</Typography>
          <Typography sx={{ fontWeight: 600 }}>{irisPhone}</Typography>
          <Button size="small" onClick={copy}>📋 Αντιγραφη</Button>
          {copied && <Typography variant="caption">Αντιγράφηκε</Typography>}
        </Stack>

        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
          * Το IRIS λειτουργεί μέσω των mobile apps των τραπεζών (άμεση μεταφορά με αριθμό κινητού).
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Κλεισιμο</Button>
      </DialogActions>
    </Dialog>
  );
}
